<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>赛务管理</el-breadcrumb-item>
      <el-breadcrumb-item
        :to="{
          path: '/raceManagement/individual_management/individual_manage_homeview/individual_race_management',
        }"
        >个人赛赛务工具</el-breadcrumb-item
      >
      <el-breadcrumb-item>优惠券详情</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <!-- 优惠券详情 -->
    <el-card style="margin-top: 15px;">
      <el-row class="title_row">
        <el-col :span="9">
          <span class="title_class">优惠券信息</span>
        </el-col>
        <el-col :span="15" style="text-align: right">
          <el-button type="primary" @click="setFn" :disabled="expire">发放优惠券</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="item">
            <div class="label">优惠券</div>
            <div class="value name">{{ pageInfo.couponName }}</div>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="item">
            <div class="label">关联产品</div>
            <div class="value">{{ pageInfo.productListName }}</div>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="item">
            <div class="label">产品详情</div>
            <div class="value">
              <el-tag style="margin-right: 12px;" v-for="(product,i) of pageInfo.productDetails" :key="i">{{ product }}</el-tag>
            </div>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="item item-start">
            <div class="label">
              使用规则
              <i class="el-icon-edit-outline edit" v-if="!editRules" @click="editRules = true"></i>
            </div>
            <div class="value" v-if="!editRules">{{ pageInfo.description }}</div>
            <div style="width: 500px;" v-else>
              <el-input type="textarea" :rows="5" v-model="pageInfo.description"></el-input>
              <div class="save-btn">
                <el-button @click="editRules = false">取消修改</el-button>
                <el-button type="primary" @click="saveRulesFn">保存修改</el-button>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="item">
            <div class="label">优惠金额</div>
            <div class="value price">¥{{ pageInfo.discountAmount }}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="item">
            <div class="label">有效期</div>
            <div class="value">
              {{ pageInfo.expirationDate }}
              <el-tag v-if="expire" type="info" size="mini">已过期</el-tag>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="item">
            <div class="label">状态</div>
            <div class="value">
              <el-tag :type="pageInfo.status ? 'success' : 'danger'" size="mini">{{ pageInfo.status ? '已上架' : '已下架' }}</el-tag>
              <el-switch style="margin-left: 12px;"
                v-model="pageInfo.status"
                active-color="#13ce66"
                inactive-color="#ff4949"
                @change="changeStatus()"
                >
              </el-switch>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="item">
            <div class="label">类型</div>
            <div class="value">{{ pageInfo.couponTypeStr }}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="item">
            <div class="label">最低购买金额</div>
            <div class="value price" v-if="pageInfo.minimumPurchase">¥{{ pageInfo.minimumPurchase }}</div>
            <div class="value" v-else>--</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="item">
            <div class="label">创建者</div>
            <div class="value">{{ pageInfo.creator }}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="item">
            <div class="label">所属活动</div>
            <div class="value">{{ pageInfo.activityTypeStr }}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="item">
            <div class="label">所属赛季</div>
            <div class="value">{{ pageInfo.season }}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="item">
            <div class="label">创建时间</div>
            <div class="value">{{ pageInfo.createTime }}</div>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <!-- 筛选 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">已发放用户信息筛选</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        class="filter_Form"
        label-width="100px"
        ref="queryFormRef"
      >
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="姓名" prop="userName">
              <el-input
                v-model="queryForm.userName"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="手机号" prop="phone">
              <el-input
                v-model="queryForm.phone"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否使用" prop="used">
              <el-select
                placeholder="请选择"
                v-model="queryForm.used"
                style="width: 100%"
              >
                <el-option label="未使用" :value="1"></el-option>
                <el-option label="已使用" :value="2"></el-option>
                <el-option label="已过期" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row :gutter="20" type="flex" justify="end">
        <el-col :span="2">
          <el-button type="primary" style="width: 100%" @click="search"
            >查询</el-button
          >
        </el-col>
        <el-col :span="2">
          <el-button type="primary" plain style="width: 100%" @click="reset"
            >重置</el-button
          >
        </el-col>
      </el-row>
    </el-card>
    <!-- 列表 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="9">
          <span class="title_class">已发放用户列表</span>
        </el-col>
        <el-col :span="15" style="text-align: right;">
          <el-button type="primary" @click="exportTable" plain
            >批量导出</el-button
          >
        </el-col>
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        stripe
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="姓名" prop="userName"></el-table-column>
        <el-table-column label="手机号" prop="phone"></el-table-column>
        <el-table-column label="年级" prop="gradeStr"></el-table-column>
        <el-table-column label="组别" prop="levelStr"></el-table-column>
        <el-table-column label="状态" prop="usedStr">
          <template slot-scope="scope">
            <el-tag :type="scope.row.used === 2 ? 'success' : scope.row.used === 3 ? 'info' : scope.row.used === 4 ? 'danger' : ''" size="mini">
              {{ scope.row.usedStr }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="下单/撤回/过期日期" prop="usedDate"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              :disabled="scope.row.used !== 1"
              @click="handleTo(scope.row)"
              >撤回</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 编辑信息的dialog -->
    <el-dialog
      title="发放优惠券"
      :visible.sync="visible"
      width="800px"
      @close="closeFn"
    >
      <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
        <el-tab-pane label="手机号查询" name="1">
          <el-row class="title row">
            <el-col :span="10">手机号</el-col>
            <el-col :span="9">姓名</el-col>
          </el-row>
          <el-row class="row" v-for="(item,index) of phoneAddList" :key="index">
            <el-col :span="10">
              <el-input v-model="item.phone" style="width: 180px;"></el-input>
              <el-button icon="el-icon-search" circle class="search" @click="getUserId(item.phone, index)"></el-button>
            </el-col>
            <el-col :span="9">
              <el-input v-model="item.name" style="width: 180px;" disabled=""></el-input>
            </el-col>
            <el-col :span="5">
              <el-button type="primary" icon="el-icon-plus" circle @click="addOneRow"></el-button>
              <el-button type="danger" icon="el-icon-delete" circle @click="delOneRow(index)" v-if="phoneAddList.length > 1"></el-button>
            </el-col>
          </el-row>
          <div class="dialog-footer">
            <el-button @click="visible = false">取 消</el-button>
            <el-button type="primary" @click="saveFn">确认发放</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="批量上传" name="2">
          <div class="upload">
            <el-upload
              class="upload-demo"
              drag
              ref="uploadFileRef"
              :action="uploadInfo.uploadUrl"
              :headers="uploadInfo.headerObj"
              :data="addForm"
              :before-upload="beforeUpload"
              :limit="1"
              :on-success="uploadSuccess"
              :on-error="uploadError">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">支持上传Excel文件， <em class="tip" @click="downLoadFn">点击下载模版</em></div>
            </el-upload>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'semi_final_form_code',
  data () {
    return {
      dict_season: this.$userInfo.getDataList(this, 't_season').then(value => { this.dict_season = value }),
      activityTypeList: this.$userInfo.getDataList(this, 'activity_type').then(value => { this.activityTypeList = value }),
      dict_Group: this.$userInfo.dict_group(),
      queryForm: {
        activityType: String(this.$chnEngStatusCode.activityType),
        season: this.$chnEngStatusCode.defaultSeason,
        couponName: '',
        couponId: '',
        phone: '',
        used: '', // 是否被使用 1未使用 2已使用 3已过期 4已撤回 5已下架
        userName: ''
      },
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      dataList: [],
      title: '',
      visible: false,
      editForm: {
        activityType: String(this.$chnEngStatusCode.activityType),
        season: this.$chnEngStatusCode.defaultSeason,
        couponName: '',
        couponType: '',
        discountAmount: '',
        expirationDate: '',
        minimumPurchase: '',
        productIds: '',
        status: 1
      },
      status: true,
      editInfoRules: {
        couponName: [{ required: true, message: '请输入', trigger: 'blur' }],
        couponType: [{ required: true, message: '请选择', trigger: 'change' }],
        discountAmount: [{ required: true, message: '请输入', trigger: 'blur' }],
        minimumPurchase: [{ required: true, message: '请输入', trigger: 'blur' }],
        expirationDate: [{ required: true, message: '请选择', trigger: 'change' }],
        season: [{ required: true, message: '请选择', trigger: 'change' }],
        productIds: [{ required: true, message: '请选择', trigger: 'change' }]

      },
      editType: '',
      dateTimeRange: [],
      productList: [],
      // ----
      id: '',
      pageInfo: {},
      activeName: '1',
      phoneAddList: [
        { phone: '', name: '', userId: '' }
      ],
      uploadInfo: {
        uploadUrl: `${this.$http.defaults.baseURL}coupon/importQueryTbUserCoupon`,
        headerObj: {
          Authorization: localStorage.getItem('Authorization')
        }
      },
      addForm: {
        couponId: ''
      },
      editRules: false,
      expire: false
    }
  },
  created () {
    this.id = this.$route.query.id
    this.getInfo()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    getInfo () {
      this.$http.get('coupon/queryTbCouponInfo', { params: { id: this.id } }).then(res => {
        if (res.code === 200) {
          this.pageInfo = res.data
          this.pageInfo.productDetails = res.data.showProductsStr ? res.data.showProductsStr.split(',') : []
          this.queryForm.couponId = res.data.id
          this.queryForm.couponName = res.data.couponName
          this.getUserList()
          this.expire = new Date(res.data.expirationDate).getTime() < new Date().getTime()
        }
      })
    },
    getUserList () {
      const params = { ...{ pageNum: this.pageIndex, pageSize: this.pageSize }, ...this.queryForm }
      this.$http.get('coupon/queryTbUserCouponPage', { params }).then(res => {
        if (res.code === 200) {
          this.total = res.data.total
          this.dataList = res.data.list
        }
      })
    },
    search () {
      this.pageIndex = 1
      this.getUserList()
    },
    reset () {
      this.queryForm.phone = ''
      this.queryForm.userName = ''
      this.queryForm.used = ''
      this.search()
    },
    handleSizeChange (e) {
      this.pageSize = e
      this.getUserList()
    },
    handleCurrentChange (e) {
      this.pageIndex = e
      this.getUserList()
    },
    closeFn () {
      this.visible = false
    },
    changeStatus () {
      this.$http.post('coupon/updateTbCouponInfo', { id: this.pageInfo.id, status: this.pageInfo.status }).then(res => {
        if (res.code === 200) {
          this.$message.success(this.pageInfo.status ? '优惠券已上架' : '优惠券已下架')
          this.getInfo()
        }
      })
    },
    setFn () {
      this.visible = true
      this.phoneAddList = [{ phone: '', name: '', userId: '' }]
      this.activeName = '1'
    },
    saveFn () {
      const userIds = this.phoneAddList.filter(item => item.userId).map(item => item.userId)
      this.$http.post('coupon/saveTbUserCoupon', {
        activityType: this.pageInfo.activityType,
        couponId: this.pageInfo.id,
        season: this.pageInfo.season,
        userIds
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('优惠券发放成功')
          this.closeFn()
          this.getUserList()
        }
      })
    },
    handleClick () {
      if (this.activeName === '2') {
        this.addForm.couponId = this.pageInfo.id
      }
    },
    addOneRow () {
      const obj = {
        phone: '', name: '', userId: ''
      }
      this.phoneAddList.push(obj)
    },
    delOneRow (index) {
      this.phoneAddList.splice(index, 1)
    },
    getUserId (phone, index) {
      if (!phone) return
      this.$http.get('erpUser/getSysUserInfo', { params: { phone } }).then(res => {
        if (res.code === 200) {
          this.phoneAddList[index].userId = res.data.userId
          this.phoneAddList[index].name = res.data.userName
        }
      })
    },
    exportTable () {
      const { activityType, season, couponId, couponName, phone, used, userName } = this.queryForm
      const downLoadUrl = `${this.$http.defaults.baseURL}coupon/excelQueryTbUserCouponPage?${this.$xcUtils.serialize({ activityType, season, couponId, couponName, phone, used, userName })}`
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl)
    },
    beforeUpload (file) {
      if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.$message.error('请选择Excel文件上传')
        return false
      }
    },
    uploadSuccess (res) {
      if (res.code === 200) {
        this.$message.success('上传成功')
        this.closeFn()
        this.getUserList()
      } else {
        this.$message.error(res.msg)
      }
      this.$refs.uploadFileRef.clearFiles()// 清除文件
    },
    uploadError (error) {
      console.log('uploadError', error)
    },
    // 下载模板
    downLoadFn () {
      var downLoadUrl = this.$http.defaults.baseURL + 'coupon/importQueryTbUserCouponTemplate'
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl, {})
    },
    handleTo (item) {
      this.$confirm('此操作将收回该选手优惠券, 请谨慎操作', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('coupon/updateTbUserCoupon', { id: item.id, used: 4 }).then(res => {
          if (res.code === 200) {
            this.$message.success('您撤回一张优惠券')
            this.getUserList()
          }
        })
      }).catch(() => {
      })
    },
    saveRulesFn () {
      this.$http.post('coupon/updateTbCouponInfo', { id: this.pageInfo.id, description: this.pageInfo.description }).then(res => {
        if (res.code === 200) {
          this.$message.success('优惠券使用规则修改成功')
          this.getInfo()
          this.editRules = false
        }
      })
    }

  }
}
</script>
<style lang="less" scoped>
.item{
  font-size: 14px;
  display: flex;
  align-items: center;
  min-height: 32px;
  margin-bottom: 12px;
}
.item-start{
  align-items: flex-start;
}
.label{
  width: 110px;
  text-align: right;
  color: #606266;
  &::after{
    content: '：';
  }
}
.value{
  white-space: pre-line;
}
.tip{
  color: #409EFF;
  cursor: pointer;
}
.upload{
  margin: 40px 0;
  text-align: center;
}
.price{
  color: #409EFF;
  font-size: 18px;
  font-weight: 600;
}
.name{
  color: #000;
  font-size: 16px;
  font-weight: bold;
}
.row{
  margin-bottom: 12px;
}
.title{
  font-weight: 600;
  color: #000;
}
.search{
  margin-left: 12px;
}
.dialog-footer{
  text-align: center;
  margin-top: 60px;
}
.edit{
  color: #409EFF;
  font-size: 18px;
  cursor: pointer;
}
.save-btn{
  margin: 10px auto;
  text-align: center;
}
</style>
